export default {
  title: 'Ajustează Comanda',
  product_info: {
    earn_points: 'Câștigă {{points}} Puncte',
  },
};
